<template>
	<li class="properties__item properties-item">
		<a :href="getPropertyUrl" class="properties-item__content" target="_blank">
			<header class="properties-item__header">
				<figure class="properties-item__figure">
					<img
						:src="getPropertyImage"
						:alt="property.titleAutogenerated"
						class="properties-item__image"
					/>
				</figure>
			</header>
			<div class="properties-item__main">
				<div class="properties-item__copy properties-item-copy">
					<h3 class="properties-item-copy__title">{{ property.titleAutogenerated }}</h3>
				</div>
			</div>
		</a>
	</li>
</template>

<script setup>
import {computed} from 'vue'
import {convertPropertyImageUrl} from '~/default/vue/realestate/realestate'

const {property} = defineProps({
	property: {
		type: Object,
		required: true,
	},
})

const getPropertyUrl = computed(() => {
	return `https://case.asiago.it/it/immobile/${property.asiagoItReferenceCode.toLowerCase()}/#main`
})

const getPropertyImage = computed(() => {
	const originalUrl = property.images.find(x => x.cover).types.find(x => x.name === 'thumb').url

	return convertPropertyImageUrl(originalUrl)
})
</script>

<style lang="scss" scoped>
// Simple Asiago.it styles reset
* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	display: block;
}
ul {
	list-style-type: none;
}
a {
	text-decoration: none;
	color: inherit;
	&:hover {
		opacity: 1;
	}
}

.properties-item {
	position: relative;
	padding: 0.25rem;
	width: 25%;
	margin: 0;
	@media not all and (min-width: 40em) {
		width: calc(100% / 3);
	}
	@media not all and (min-width: 30em) {
		width: 50%;
	}
	.properties-item__content {
		position: relative;
		width: 100%;
		height: 100%;
		background: #fff;
		color: #333;
		display: flex;
		flex-flow: column nowrap;
		align-items: stretch;
		justify-content: center;
		transition: all 0.3s;
		box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.15);
		&:hover {
			box-shadow: 0 0 1rem rgba(0, 0, 0, 0.25);
			.properties-item__image {
				transform: scale(1.05);
			}
		}
	}
	.properties-item__header {
		width: 100%;
		position: relative;
		overflow: hidden;
		.properties-item__figure {
			position: relative;
			width: 100%;
			height: 0;
			padding-bottom: calc(3 / 4 * 100%);
			overflow: hidden;
			&::after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.68));
				z-index: 1;
			}
			.properties-item__image {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				object-fit: cover;
				transition: all 1s;
				margin: 0;
				z-index: 0;
			}
		}
	}
	.properties-item__main {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 2;
		padding: 5px;
		flex-grow: 1;
		display: flex;
		flex-flow: column nowrap;
		align-items: flex-start;
		justify-content: flex-start;
		.properties-item-copy {
			flex-grow: 1;
			display: flex;
			flex-flow: column nowrap;
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;
			&__title {
				font-weight: 700;
				font-size: 10px;
				line-height: normal;
				color: #fff;
				text-transform: uppercase;
				text-shadow: 1px 1px 3px rgb(0 0 0 / 60%);
			}
		}
	}
}
</style>
